import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiSearch, FiX } from 'react-icons/fi';
import './SearchBar.css';

/**
 * Search bar component for player username input
 */
const SearchBar = ({ onSearch, onClear, isLoading, hasResults }) => {
  const [query, setQuery] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  // Focus input on mount
  useEffect(() => {
    if (inputRef.current && !hasResults) {
      inputRef.current.focus();
    }
  }, [hasResults]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim() && !isLoading) {
      onSearch(query.trim());
    }
  };

  const handleClear = () => {
    setQuery('');
    onClear();
    inputRef.current?.focus();
  };

  return (
    <motion.form
      className={`search-bar ${isFocused ? 'focused' : ''}`}
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.3 }}
    >
      <div className="search-container">
        <div className="search-icon">
          <FiSearch />
        </div>

        <input
          ref={inputRef}
          type="text"
          className="search-input"
          placeholder="Enter Minecraft username..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={isLoading}
          maxLength={16}
          autoComplete="off"
          spellCheck="false"
        />

        {query && (
          <motion.button
            type="button"
            className="clear-button"
            onClick={handleClear}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FiX />
          </motion.button>
        )}

        <motion.button
          type="submit"
          className="search-button"
          disabled={!query.trim() || isLoading}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {isLoading ? (
            <span className="button-loading">
              <span className="spinner"></span>
              Searching...
            </span>
          ) : (
            'Search'
          )}
        </motion.button>
      </div>

      <p className="search-hint">
        Press <kbd>Enter</kbd> to search
      </p>
    </motion.form>
  );
};

export default SearchBar;
